module.exports = __webpack_public_path__ + "img/8b35c32.jpg";